export function getDraftFormPayload(values) {
  return values
}
